<template>
    <span class="ah-receipt-number">
        <span class="words">{{ formatedNumber.words }}</span
        ><span class="numbers">{{ formatedNumber.numbers }}</span>
    </span>
</template>
<script>
export default {
    props: {
        v: {
            type: String,
            default: '',
        },
    },
    computed: {
        formatedNumber() {
            if (typeof this.v !== 'string') return { words: '', numbers: '' };
            if (this.v.length < 3) return { words: this.v, numbers: '' };

            return { words: this.v.slice(0, 2), numbers: this.v.slice(2) };
        },
    },
};
</script>
<style scoped>
.ah-receipt-number {
    color: #000;
    font-weight: bold;

    .words {
        padding-right: 4px;
    }
}
</style>
